import { useState } from 'react';

interface NotifItem {
  id: string;
  icon: string;
  label: string;
  desc: string;
  defaultOn: boolean;
}

const notifItems: NotifItem[] = [
  { id: 'match_found', icon: 'ri-user-received-2-line', label: 'Eşleşme Bulundu', desc: 'Yeni bir eşleşme hazır olduğunda bildir.', defaultOn: true },
  { id: 'new_message', icon: 'ri-chat-3-line', label: 'Yeni Mesaj', desc: 'Sohbet ekranında yeni mesaj geldiğinde titreşim/ses.', defaultOn: true },
  { id: 'premium_offer', icon: 'ri-vip-crown-line', label: 'Premium Teklifleri', desc: 'Özel indirimler ve Premium kampanyaları hakkında bilgi al.', defaultOn: false },
  { id: 'system', icon: 'ri-settings-3-line', label: 'Sistem Bildirimleri', desc: 'Güvenlik uyarıları ve hesap bildirimleri.', defaultOn: true },
  { id: 'newsletter', icon: 'ri-mail-line', label: 'E-posta Bülteni', desc: 'Platform haberleri ve güncellemeler e-postana gelsin.', defaultOn: false },
];

const NotificationsSection = () => {
  const [states, setStates] = useState<Record<string, boolean>>(
    Object.fromEntries(notifItems.map((n) => [n.id, n.defaultOn]))
  );
  const [sound, setSound] = useState(true);
  const [vibration, setVibration] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const handleSave = () => {
    setSaving(true);
    setTimeout(() => { setSaving(false); setSaved(true); setTimeout(() => setSaved(false), 2500); }, 900);
  };

  return (
    <div>
      <div className="mb-8">
        <h2 className="text-xl font-extrabold text-white mb-1">Bildirimler</h2>
        <p className="text-white/40 text-sm">Hangi bildirimleri almak istediğini seç.</p>
      </div>

      {/* Sound & Vibration */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
        {[
          { id: 'sound', icon: 'ri-volume-up-line', label: 'Ses', desc: 'Bildirim sesi', val: sound, set: setSound },
          { id: 'vib', icon: 'ri-shake-hands-line', label: 'Titreşim', desc: 'Mobil titreşim', val: vibration, set: setVibration },
        ].map((item) => (
          <div key={item.id} className="flex items-center justify-between gap-3 p-5 rounded-2xl bg-white/3 border border-white/8">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/6 text-white/40">
                <i className={`${item.icon} text-base`} />
              </div>
              <div>
                <p className="text-white/80 text-sm font-semibold">{item.label}</p>
                <p className="text-white/30 text-xs">{item.desc}</p>
              </div>
            </div>
            <button
              onClick={() => item.set((v: boolean) => !v)}
              className={`relative w-12 h-6 rounded-full flex-shrink-0 transition-all duration-300 cursor-pointer ${item.val ? 'bg-cyan-500' : 'bg-white/10'}`}
            >
              <div className={`absolute top-1 w-4 h-4 rounded-full bg-white shadow-sm transition-all duration-300 ${item.val ? 'left-7' : 'left-1'}`} />
            </button>
          </div>
        ))}
      </div>

      {/* Notif items */}
      <div className="flex flex-col gap-3 mb-6">
        {notifItems.map((n) => (
          <div key={n.id} className="flex items-center justify-between gap-4 p-5 rounded-2xl bg-white/3 border border-white/8">
            <div className="flex items-start gap-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/6 text-white/40 flex-shrink-0 mt-0.5">
                <i className={`${n.icon} text-base`} />
              </div>
              <div>
                <p className="text-white/80 text-sm font-semibold">{n.label}</p>
                <p className="text-white/35 text-xs mt-0.5">{n.desc}</p>
              </div>
            </div>
            <button
              onClick={() => setStates((p) => ({ ...p, [n.id]: !p[n.id] }))}
              className={`relative w-12 h-6 rounded-full flex-shrink-0 transition-all duration-300 cursor-pointer ${states[n.id] ? 'bg-cyan-500' : 'bg-white/10'}`}
            >
              <div className={`absolute top-1 w-4 h-4 rounded-full bg-white shadow-sm transition-all duration-300 ${states[n.id] ? 'left-7' : 'left-1'}`} />
            </button>
          </div>
        ))}
      </div>

      <button
        onClick={handleSave}
        disabled={saving}
        className="px-8 py-3.5 rounded-full bg-gradient-to-r from-cyan-500 to-violet-600 text-white font-bold text-sm hover:from-cyan-400 hover:to-violet-500 transition-all cursor-pointer disabled:opacity-60 whitespace-nowrap shadow-lg shadow-cyan-500/20"
      >
        {saving ? (
          <span className="flex items-center gap-2"><i className="ri-loader-4-line animate-spin" /> Kaydediliyor...</span>
        ) : saved ? (
          <span className="flex items-center gap-2 text-emerald-300"><i className="ri-checkbox-circle-line" /> Kaydedildi!</span>
        ) : (
          <span className="flex items-center gap-2"><i className="ri-save-line" /> Kaydet</span>
        )}
      </button>
    </div>
  );
};

export default NotificationsSection;
